import styled from 'styled-components';

export const GoCashComp = styled.div`
background: #FFFFFF;
border-radius: 8px;
margin: ${(p) => p.margin ? p.margin : ''};
margin-bottom: 1.5rem;
`;

export const GoCashTitle = styled.div`
display: flex;
align-items:center;
font-weight: 700;
font-size: 18px;
line-height: 20px;
font-family: quicksand;
`;

export const GoCashIcon = styled.img.attrs((props) => ({
    src: props.src || "",
  }))`
    width: 27px;
    height: 24px;
    margin: 0 0.5rem 0 0
  `;

export const GoCashHeader = styled.div`
padding:12px 16px;
border-bottom: 1px solid #ebebeb;
color: #000;
display: flex;
align-items:center;
justify-content:space-between;
`;

export const GoCashDetails = styled.div`
font-size: 12px;
line-height: 14px;
color: #777777;
padding: 8px 12px;

& .balance{font-weight:700;margin-bottom:4px;}
`;

export const ToggleBtn = styled.div`
border-radius: 10px;
background: #fff;
`;

export const GoCashToogleWrap = styled.div`
display: flex;
align-items:center;

& .onText{
    font-size: 12px;
    line-height:14px;
    font-weight:700;
    color: #18A160;
    margin-right:8px;
}

& .offText{
    font-size: 12px;
    line-height:14px;
    font-weight:700;
    color: #647A97;
    margin-right:8px;
}
`;

export const ToggleStatus = styled.div`
    width: 40px;
    height:24px;
    border-radius: 12px;
    display: flex;
    align-items:center;
    padding: 0 4px;
    font-weight:700;
    cursor: pointer;

    &.buttonOff{background: #E1E7EE;}

    &.buttonOn{background: #E9F6EA;}

    & .off{
    width:16px;
    height: 16px;
    border-radius: 100%;
    background: #647A97;
    padding: 0px 2px;
    justify-content: center;
    display: flex;
    }

    & .on{
    width:16px;
    height: 16px;
    border-radius: 100%;
    background-color: #18A160;
    padding: 0px 2px;
    justify-content: center; 
    display: flex;
    align-items:center;
    margin-left:auto;
              
    }
`;
